module.exports = __webpack_public_path__ + "static/media/plotter2.1b4c92ce.png";